/** Reads a failed request in the operator's language with the Control Center's strings (see `apiErrorText.ts`). */

import i18n from '../i18n';
import { errorTextWith, type ErrorText } from './apiErrorText';

export type { ErrorText } from './apiErrorText';

/** The operator's sentence for a failed request (an `ApiError`, another `Error`, or anything thrown). */
export function errorText(error: unknown): ErrorText {
  const t = i18n.t.bind(i18n) as unknown as (key: string, options: { ns: string }) => string;
  const lookup = (key: string) => (i18n.exists(key, { ns: 'common' }) ? t(key, { ns: 'common' }) : undefined);
  return errorTextWith(error, lookup, (i18n.language ?? 'vi').startsWith('vi'));
}
